/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * TipMi Admin API
 * Admin console backend API consumed by tipmi-admin-web
 * OpenAPI spec version: v1
 */
import { useQuery } from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';

import type {
  GetEngagementDashboardParams,
  SuccessResponseDTOEngagementDashboardResponseDTO,
} from '.././model';

import { customInstance } from '../../http';

/**
 * @summary Get platform engagement dashboard snapshot
 */
export const getEngagementDashboard = (
  params?: GetEngagementDashboardParams,
  signal?: AbortSignal,
) => {
  return customInstance<SuccessResponseDTOEngagementDashboardResponseDTO>({
    url: `/admin/api/engagement/dashboard`,
    method: 'GET',
    params,
    ...(signal ? { signal } : {}),
  });
};

export const getGetEngagementDashboardQueryKey = (params?: GetEngagementDashboardParams) => {
  return [`/admin/api/engagement/dashboard`, ...(params ? [params] : [])] as const;
};

export const getGetEngagementDashboardQueryOptions = <
  TData = Awaited<ReturnType<typeof getEngagementDashboard>>,
  TError = unknown,
>(
  params?: GetEngagementDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEngagementDashboard>>, TError, TData>
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetEngagementDashboardQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getEngagementDashboard>>> = ({ signal }) =>
    getEngagementDashboard(params, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getEngagementDashboard>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData> };
};

export type GetEngagementDashboardQueryResult = NonNullable<
  Awaited<ReturnType<typeof getEngagementDashboard>>
>;
export type GetEngagementDashboardQueryError = unknown;

export function useGetEngagementDashboard<
  TData = Awaited<ReturnType<typeof getEngagementDashboard>>,
  TError = unknown,
>(
  params: undefined | GetEngagementDashboardParams,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEngagementDashboard>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEngagementDashboard>>,
          TError,
          Awaited<ReturnType<typeof getEngagementDashboard>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEngagementDashboard<
  TData = Awaited<ReturnType<typeof getEngagementDashboard>>,
  TError = unknown,
>(
  params?: GetEngagementDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEngagementDashboard>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getEngagementDashboard>>,
          TError,
          Awaited<ReturnType<typeof getEngagementDashboard>>
        >,
        'initialData'
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
export function useGetEngagementDashboard<
  TData = Awaited<ReturnType<typeof getEngagementDashboard>>,
  TError = unknown,
>(
  params?: GetEngagementDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEngagementDashboard>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };
/**
 * @summary Get platform engagement dashboard snapshot
 */

export function useGetEngagementDashboard<
  TData = Awaited<ReturnType<typeof getEngagementDashboard>>,
  TError = unknown,
>(
  params?: GetEngagementDashboardParams,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getEngagementDashboard>>, TError, TData>
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {
  const queryOptions = getGetEngagementDashboardQueryOptions(params, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}
